<section class="occasion" aria-labelledby="wishlist-nearest-occasion-title">
  @if (view(); as occasion) {
    <button class="panel" type="button" (click)="handleSelected()">
      <span class="topline">
        <span class="eyebrow">
          <svg
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            aria-hidden="true"
          >
            <path
              d="M4 8h12v9H4zM3 8h14M10 8V4M7 4c0 1.5 3 4 3 4s3-2.5 3-4a1.5 1.5 0 0 0-3 0 1.5 1.5 0 0 0-3 0Z"
            />
          </svg>
          Najbliższa okazja
        </span>
        <span class="countdown">{{ occasion.countdownLabel }}</span>
      </span>
      <span
        class="title"
        id="wishlist-nearest-occasion-title"
        role="heading"
        aria-level="2"
        >{{ occasion.title }}</span
      >
      <span class="description">{{ occasion.description }}</span>
      <span class="recipient">
        <ui-avatar
          [initials]="beneficiaryInitials()"
          [label]="occasion.beneficiaryLabel"
          [size]="36"
          tone="neutral"
        />
        <span>
          <strong>{{ occasion.beneficiaryLabel }}</strong>
          <small>{{ occasion.dateLabel }} · {{ occasion.giftsLabel }}</small>
        </span>
      </span>
      @if (occasion.reservationsLabel !== null) {
        <span class="reservation-count">{{ occasion.reservationsLabel }}</span>
        <span class="progress-track" aria-hidden="true"
          ><span [style.inline-size.%]="progressPercent()"></span
        ></span>
        @if (hasPending()) {
          <span class="pending">{{ occasion.pendingLabel }}</span>
        }
      }
    </button>
  } @else {
    <article class="empty-panel">
      <h2 id="wishlist-nearest-occasion-title">Brak nadchodzącej okazji</h2>
      <p>Dodaj datę do aktywnej wishlisty, żeby pojawiła się tutaj.</p>
    </article>
  }
</section>
